import React from 'react';
import background from '../../assets/cnsa.jpg';
import ReusableInfoCard from '../../components/ReusableInfoCard/ReusableInfoCard';


class InfoCnsa extends React.Component {
  render () { 
   return(
  
  <ReusableInfoCard             
    
        tag="NEAR SPACE"
        subtag="Beijing, China"
        description="CNSA"
        paragraph="China National Space Administration is the national space agency of China. It is responsible for the national space program and for planning and development of space activities."
        background={background}
     />
  
  );
 }
}   

export default InfoCnsa;